import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export const WelcomePage = (): ReactElement => {
  const { t } = useTranslation()

  const welcomeHeader = t('welcomeHeader', 'Welcome to Calabrio ONE')
  const bodyText = t('welcomeDefaultBody', 'Please select an application from the navigation bar to continue.')

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <h1 className="text-5xl">{welcomeHeader}</h1>
      <p className="text-base">{bodyText}</p>
    </div>
  )
}
